import React from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Button, cn } from '@duck/ui'
import { useTar } from '@/modules'

interface ErrorStateProps {
  title?: string
  description?: string
  onRetry?: () => void
  retryText?: string
  icon?: React.ComponentType<{ className?: string }>
  className?: string
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  description,
  onRetry,
  retryText,
  icon: Icon = ExclamationTriangleIcon,
  className,
}) => {
  const { t } = useTar()

  return (
    <div
      className={cn(
        'mx-auto flex max-w-md flex-col items-center px-4 py-12 text-center',
        className
      )}
    >
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
        <Icon className="h-8 w-8 text-destructive" />
      </div>
      <h3 className="mb-2 text-xl font-semibold text-foreground">
        {title || t('common.somethingWentWrong')}
      </h3>
      {description && (
        <p className="mb-6 text-muted-foreground">{description}</p>
      )}
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          {retryText || t('common.tryAgain')}
        </Button>
      )}
    </div>
  )
}
